"use client"
import React, { forwardRef } from "react"
import { useContextSelector } from "use-context-selector"
import { classNames } from "../../utils"
import { UnstyledButton } from "../UnstyledButton"
import { CarouselContext as MainCarouselContext } from "./CarouselProvider"

type CarouselNavigationDotsProps = {
  className?: string
  dotClassName?: string
}

export const CarouselNavigationDots = forwardRef<
  HTMLDivElement,
  CarouselNavigationDotsProps
>(function CarouselNavigationDots({ className, dotClassName, ...props }, ref) {
  const [api, selectedIndex, scrollTo] = useContextSelector(
    MainCarouselContext,
    ctx => [ctx?.api, ctx?.selectedIndex, ctx?.scrollTo],
  )
  const slideCount = api?.slideNodes().length

  if (!slideCount) {
    return null
  }

  return (
    <div
      className={classNames(
        "flex h-3 items-center justify-center gap-2.5",
        className,
      )}
      ref={ref}
      {...props}
    >
      {Array.from({ length: slideCount }).map((_, index) => (
        <UnstyledButton
          className={classNames("group -my-3.5 h-5 w-10", dotClassName)}
          key={index}
          onClick={() => scrollTo?.(index)}
        >
          <div
            className={classNames(
              "h-1.5 w-full rounded bg-bg-additional-2",
              "transition-colors duration-200 ease-out-quint",
              index === selectedIndex
                ? "bg-text-primary"
                : "group-hover:bg-bg-additional-3",
              dotClassName,
            )}
            data-testid="dot-inner"
          />
        </UnstyledButton>
      ))}
    </div>
  )
})
